import React, { type JSX } from 'react';
import query from './EkonomiskAnalysColumnCaptionQuery.gql';
import type {
  EkonomiskAnalysColumnCaptionQueryVariables as IVariables,
  EkonomiskAnalysColumnCaptionQuery as IData,
  EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns as IColumnHeaderInfo,
} from './_QueryTypes/EkonomiskAnalysColumnCaptionQuery';
import { Query } from '@apollo/client/react/components';
import { IColumn } from '../EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import {
  colToInputCol,
  datesToPartialTimeInterval,
} from '../../Utils/convertUtils';
import { IEkonomiskAnalysDates } from '../../Components/AnalysSettingsHandler/AnalysSettingsHandler';

interface IProps {
  columns: IColumn[];
  codePrivilegeId: string;
  analysName: string;
  children: (columns?: IColumn[] | undefined) => JSX.Element;
  dates: IEkonomiskAnalysDates;
  onUpdate: (columns: IColumn[]) => void;
  isInterval: boolean;
}

export const getColumnName = (header: IColumnHeaderInfo): string => {
  const rubrik3 = header.rubrik3 ? ` ${header.rubrik3}` : '';
  const rubrik2 = header.rubrik2 ? ` ${header.rubrik2}` : '';
  const rubrik1 = header.rubrik1 ? header.rubrik1 : '';
  return rubrik1 + rubrik2 + rubrik3;
};

/** Query, som givet en analys parsar och returnerar dess rubriker */
class EkonomiskAnalysColumnCaptionQuery extends React.Component<IProps> {
  oldColumns: IColumn[] | undefined = undefined;

  render() {
    const skip = !this.props.columns.some(col => col.displayLabel == null);

    return (
      <Query<IData, IVariables>
        skip={skip}
        query={query}
        variables={{
          analys: {
            name: this.props.analysName,
            columns: this.props.columns.map(col => colToInputCol(col.data)),
            sums: null,
          },
          codePrivilegeId: this.props.codePrivilegeId,
          tidsintervall: datesToPartialTimeInterval(
            this.props.dates,
            this.props.isInterval
          ),
        }}
        notifyOnNetworkStatusChange
      >
        {({ data, loading, error }) => {
          if (loading) {
            return this.props.children(this.oldColumns);
          } else if (
            !error &&
            data &&
            data.ekanalyskolumninfoperanalys &&
            data.ekanalyskolumninfoperanalys &&
            data.ekanalyskolumninfoperanalys.columns
          ) {
            const resultColumns = data.ekanalyskolumninfoperanalys.columns;

            const cols = this.props.columns.map((col, index) => ({
              ...col,
              displayLabel: getColumnName(resultColumns[index]),
            }));

            this.oldColumns = cols;

            this.props.onUpdate(cols);
            return this.props.children();
          } else if (skip) {
            return this.props.children();
          } else {
            return null;
          }
        }}
      </Query>
    );
  }
}

export default EkonomiskAnalysColumnCaptionQuery;
export { IColumnHeaderInfo };
